function makeAluminaGlobal() {
    const __window = window;
    if (!__window.__aluminaGlobal) {
        __window.__aluminaGlobal = {
            rerender: () => { },
            asyncRerenderFlag: false,
            hookEffectFuncs: [],
            debug: {
                nAll: 0,
                nUpdated: 0,
                nPatchCall: 0,
            },
            prevRootVdom: undefined,
            jsxCreateElementFunction: undefined,
            asyncLoopInitialized: false,
            gHookInstance: undefined,
            gSheet: undefined,
            cssTextToClassNameMap: {},
            seqClassNameIndex: 0,
            classNameIndexTable: {},
            cssClassNameToTextMap: {},
        };
    }
    return __window.__aluminaGlobal;
}
export const aluminaGlobal = makeAluminaGlobal();
//# sourceMappingURL=aluminaGlobal.js.map